import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { CustomTrans } from "./CustomTrans";
import { ITextBlock } from "./types";

interface Props extends ITextBlock {}

export const TextBlock: FC<Props> = ({ title, intro, textSubBlocks }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-7 font-medium">
      {title && (
        <h2 className="text-2xl font-semibold">
          {t(title.i18nKey, title.i18nParams)}
        </h2>
      )}

      {intro && <CustomTrans {...intro} />}

      <ul className="flex flex-col gap-7">
        {textSubBlocks.map(({ id, subheading, text }) => (
          <li key={id} className="flex flex-col gap-5">
            {subheading && (
              <h3 className="text-20 font-steppe font-semibold">
                {t(subheading.i18nKey, subheading.i18nParams)}
              </h3>
            )}

            <div>
              <CustomTrans {...text} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
